import { Autocomplete, Libraries, useJsApiLoader } from '@react-google-maps/api';
import { Form, Input } from 'antd';
import { useCallback, useState } from 'react';

const libraries = ['places'] as Libraries;

interface GoogleAutocompleteProps {
	name: number,
	setAddress: (field: string, name: number, address?: string, zip?: string) => void
	field: string
}

export const GoogleAutocomplete = ({ name, setAddress, field }: GoogleAutocompleteProps) => {
	const [map, setMap] = useState<google.maps.places.Autocomplete | null>(null);
	const { isLoaded } = useJsApiLoader({
		googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAPS || '',
		language: 'en',
		libraries,
		region: 'us',
		id: 'google-map'
	});
	const onLoad = useCallback((map: google.maps.places.Autocomplete) => {
		setMap(map);
	}, []);

	const onUnmount = useCallback(() => {
		setMap(null);
	}, []);

	const onPlaceChanged = () => {
		if (map) {
			const place = map.getPlace();
			const zip = place.address_components?.find((el) => el.types[0] === 'postal_code')?.long_name;
			setAddress(field, name, place?.name, zip);
		}
	};
	return isLoaded && (
		<Autocomplete
			onLoad={onLoad}
			onPlaceChanged={() => onPlaceChanged()}
			onUnmount={onUnmount}
		>
			<Form.Item
				name={[name, 'full_address']}
				label={`${field} address`}
				style={{ width: '100%' }}
			>
				<Input placeholder="Search address..." disabled={!isLoaded} />
			</Form.Item>
		</Autocomplete>
	);
};
